import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { usePageContext } from '@xing-com/crate-entity-pages-common';
import { ShareTabOmView } from '@xing-com/crate-social-share';
import { IconMore } from '@xing-com/icons';
import { trackClickHeaderMoreAction } from '@xing-com/crate-entity-pages-common/src/tracking'; // eslint-disable-line
import { usePopOver } from '@xing-com/pop-over';

import * as Styled from './header-more-actions.styles';
import MenuContainer from './menu-container';

type HeaderMoreActionsProps = {
  smallOnWide?: boolean;
};
const HeaderMoreActions: FC<HeaderMoreActionsProps> = ({ smallOnWide }) => {
  const popOver = usePopOver();
  const { pageContext } = usePageContext();
  const { formatMessage } = useIntl();
  const { isEditor, url: pageUrl, globalId, moduleTitle } = pageContext;

  const moreButtonClick = (isEditor: boolean) => {
    popOver.handleShow();
    trackClickHeaderMoreAction({ isEditor });
  };

  const getPage = (moduleTitle?: string) => {
    if (!moduleTitle) return 'entity_pages/overview';
    const slug = moduleTitle
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/(^_|_$)/g, '');
    return `entity_pages/subpage/${slug}`;
  };

  const page = getPage(moduleTitle);

  return (
    <Styled.Wrapper>
      <Styled.Button
        variant={'tertiary'}
        data-testid={'MODAL_TOGGLE'}
        onClick={() => moreButtonClick(isEditor)}
        innerRef={popOver.triggerRef}
        size={'medium'}
        sizeWide={smallOnWide ? 'small' : undefined}
        aria-label={formatMessage({
          id: 'ARTICLES_ARTICLE_VIEWER_ARIA_LABEL_BUTTON_MORE',
        })}
        aria-expanded={popOver.show}
      >
        <IconMore width={16} height={16} />
      </Styled.Button>
      <ShareTabOmView
        url={pageUrl ?? ''}
        propChannel="wbm/EntityPages"
        entryPoint="entity_page_social_share"
        interactionTargetUrn={globalId}
        trigger={(trigger) => (
          <MenuContainer sharePage={trigger} popOver={popOver} />
        )}
        backendTrackingMetaData={{ page }}
      />
    </Styled.Wrapper>
  );
};

export default HeaderMoreActions;
